<template>
  <div>
    <div class="page flex-col">
      <div class="box_1 flex-col">
        <!-- 头部导航组件 -->
        <HeaderNav />
        
        <!-- 统一的顶部装饰和图片 -->
        <div class="box_1-spacer flex-col"></div>
        <div class="box_2 flex-col"></div>
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          :src="getImageUrl(siteConfig?.['pic_预约咨询']) || '/files/images/M5.jpg'"
        />
        
        <div class="reserve-content flex-col">
      <div class="reserve-header flex-col">
        <h1 class="reserve-title">预约咨询</h1>
        <p class="reserve-subtitle">APPOINTMENT CONSULTATION</p>
      </div>
      
      <div class="reserve-form-wrapper flex-col">
        <form @submit.prevent="submitReserve" class="reserve-form flex-col">
          <div class="form-item flex-col">
            <label class="form-label">主题 <span class="required">*</span></label>
            <input
              v-model="formData.title"
              type="text"
              class="form-input"
              placeholder="请输入主题"
              required
            />
          </div>
          
          <div class="form-item flex-col">
            <label class="form-label">姓名 <span class="required">*</span></label>
            <input
              v-model="formData.name"
              type="text"
              class="form-input"
              placeholder="请输入姓名"
              required
            />
          </div>
          
          <div class="form-item flex-col">
            <label class="form-label">电话 <span class="required">*</span></label>
            <input
              v-model="formData.phone"
              type="tel"
              class="form-input"
              placeholder="请输入联系电话"
              required
            />
          </div>
          
          <div class="form-item flex-col">
            <label class="form-label">备注</label>
            <textarea
              v-model="formData.remark"
              class="form-textarea"
              placeholder="请输入备注信息（选填）"
              rows="5"
            ></textarea>
          </div>
          
          <div class="form-actions flex-row">
            <button type="submit" class="submit-btn" :disabled="submitting">
              {{ submitting ? '提交中...' : '提交' }}
            </button>
            <button type="button" class="reset-btn" @click="resetForm">重置</button>
          </div>
        </form>
      </div>
      </div>
      
      <!-- 底部组件 -->
    </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { reserve } from '@/api/home';
import { getImageUrl } from '@/config/api';
import { getSiteConfig } from '@/store/siteConfig';

export default {
  name: 'Reserve',
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      formData: {
        title: '',
        name: '',
        phone: '',
        remark: ''
      },
      submitting: false
    };
  },
  computed: {
    siteConfig() {
      return getSiteConfig();
    }
  },
  methods: {
    // 提交预约咨询
    async submitReserve() {
      // 验证必填字段
      if (!this.formData.title || !this.formData.name || !this.formData.phone) {
        this.$toast && this.$toast.fail('请填写必填项');
        return;
      }
      
      // 验证手机号格式（简单验证）
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.formData.phone)) {
        this.$toast && this.$toast.fail('请输入正确的手机号码');
        return;
      }
      
      this.submitting = true;
      try {
        const res = await reserve(this.formData);
        if (res.code === 0) {
          this.$toast && this.$toast.success('提交成功！我们会尽快与您联系');
          this.resetForm();
        } else {
          this.$toast && this.$toast.fail(res.msg || '提交失败，请稍后重试');
        }
      } catch (error) {
        console.error('提交预约咨询失败:', error);
        this.$toast && this.$toast.fail('提交失败，请稍后重试');
      } finally {
        this.submitting = false;
      }
    },
    // 重置表单
    resetForm() {
      this.formData = {
        title: '',
        name: '',
        phone: '',
        remark: ''
      };
    },
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    }
  }
};
</script>

<style scoped>
/* 页面容器 - 自适应 */
.page {
  position: relative !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100vh !important;
  margin: 0 auto !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  box-sizing: border-box !important;
}

/* 主容器 - 自适应 */
.box_1 {
  background-color: rgba(255, 255, 255, 1) !important;
  position: relative !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100vh !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

/* 统一的顶部装饰和图片样式 - 自适应 */
.box_1-spacer {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100px !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.box_2 {
  background-color: rgba(0, 149, 151, 1) !important;
  width: 100% !important;
  max-width: 36px !important;
  height: 4px !important;
  margin: 50px auto 0 !important;
  box-sizing: border-box !important;
}

.image_1 {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: -53px auto 0 !important;
  object-fit: cover !important;
  display: block !important;
  box-sizing: border-box !important;
}

/* 预约内容区域 - 自适应 */
.reserve-content {
  width: 100% !important;
  max-width: 1200px !important;
  margin: 42px auto 0 !important;
  padding: 60px 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
}

.reserve-header {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  margin-bottom: 50px !important;
  padding-bottom: 30px !important;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2) !important;
  box-sizing: border-box !important;
}

.reserve-title {
  width: auto !important;
  height: auto !important;
  font-size: clamp(28px, 4vw, 36px) !important; /* 响应式字体 */
  font-weight: bold !important;
  color: rgba(0, 149, 151, 1) !important;
  margin: 0 0 10px 0 !important;
  text-align: center !important;
  line-height: 1.2 !important;
}

.reserve-subtitle {
  width: auto !important;
  height: auto !important;
  font-size: clamp(14px, 1.5vw, 18px) !important; /* 响应式字体 */
  color: #666 !important;
  margin: 0 !important;
  text-align: center !important;
  letter-spacing: 2px !important;
  line-height: 1.2 !important;
}

.reserve-form-wrapper {
  width: 100% !important;
  max-width: 800px !important;
  margin: 0 auto !important;
  padding: 60px 40px !important;
  background: #f9f9f9 !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
  box-sizing: border-box !important;
}

.reserve-form {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 35px !important;
  box-sizing: border-box !important;
}

.form-item {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  box-sizing: border-box !important;
}

.form-label {
  width: auto !important;
  height: auto !important;
  font-size: clamp(16px, 2vw, 18px) !important; /* 响应式字体 */
  font-weight: 500 !important;
  color: #333 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
}

.required {
  color: #ff4d4f !important;
  margin-left: 2px !important;
}

.form-input,
.form-textarea {
  width: 100% !important;
  padding: clamp(14px, 2vw, 18px) clamp(18px, 2.5vw, 24px) !important;
  border: 2px solid #ddd !important;
  border-radius: 8px !important;
  font-size: clamp(16px, 2vw, 18px) !important; /* 响应式字体 */
  font-family: inherit !important;
  transition: all 0.3s !important;
  box-sizing: border-box !important;
  background: #fff !important;
  line-height: 1.5 !important;
}

.form-input:hover,
.form-textarea:hover {
  border-color: rgba(0, 149, 151, 0.5) !important;
}

.form-input:focus,
.form-textarea:focus {
  outline: none !important;
  border-color: rgba(0, 149, 151, 1) !important;
  box-shadow: 0 0 0 3px rgba(0, 149, 151, 0.1) !important;
}

.form-textarea {
  resize: vertical !important;
  min-height: clamp(120px, 15vw, 160px) !important;
  line-height: 1.6 !important;
}

.form-actions {
  width: 100% !important;
  display: flex !important;
  flex-direction: row !important;
  gap: 25px !important;
  margin-top: 20px !important;
  justify-content: center !important;
  flex-wrap: wrap !important;
  box-sizing: border-box !important;
}

.submit-btn,
.reset-btn {
  padding: clamp(14px, 2vw, 16px) clamp(40px, 6vw, 60px) !important;
  border: none !important;
  border-radius: 8px !important;
  font-size: clamp(16px, 2vw, 18px) !important; /* 响应式字体 */
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.3s !important;
  min-width: clamp(120px, 15vw, 150px) !important;
  box-sizing: border-box !important;
}

.submit-btn {
  background-color: rgba(0, 149, 151, 1) !important;
  color: #fff !important;
  box-shadow: 0 4px 12px rgba(0, 149, 151, 0.3) !important;
}

.submit-btn:hover:not(:disabled) {
  background-color: rgba(0, 149, 151, 0.9) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 16px rgba(0, 149, 151, 0.4) !important;
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0) !important;
}

.submit-btn:disabled {
  background-color: #ccc !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}

.reset-btn {
  background-color: #fff !important;
  color: #666 !important;
  border: 2px solid #ddd !important;
}

.reset-btn:hover {
  background-color: #f5f5f5 !important;
  border-color: #bbb !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.footer-wrapper {
  width: 100% !important;
  max-width: 1920px !important;
  margin: 80px auto 0 !important;
  box-sizing: border-box !important;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .box_1-spacer {
    min-height: 80px !important;
  }

  .box_2 {
    margin: 30px auto 0 !important;
  }

  .image_1 {
    margin: -40px auto 0 !important;
    min-height: 300px !important;
  }

  .reserve-content {
    padding: 40px 15px !important;
    margin: 30px auto 0 !important;
  }

  .reserve-header {
    margin-bottom: 30px !important;
    padding-bottom: 20px !important;
  }

  .reserve-form-wrapper {
    padding: 30px 20px !important;
  }

  .reserve-form {
    gap: 25px !important;
  }

  .form-item {
    gap: 10px !important;
  }

  .form-actions {
    flex-direction: column !important;
    gap: 15px !important;
  }

  .submit-btn,
  .reset-btn {
    width: 100% !important;
    min-width: auto !important;
  }
}
</style>

